import { render } from "./forgot_password.vue?vue&type=template&id=0d49fece"
import script from "./forgot_password.vue?vue&type=script&lang=js"
export * from "./forgot_password.vue?vue&type=script&lang=js"

import "./forgot_password.vue?vue&type=style&index=0&id=0d49fece&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__